import styled, { css } from 'styled-components';

export const Container = styled.div<{ hasPadding: boolean }>`
  gap: 24px;
  display: flex;
  flex-direction: column;
  ${({ hasPadding }) =>
    hasPadding &&
    css`
      padding: 16px;
    `}
`;

export const InfoLabel = styled.div`
  color: ${({ theme }) => theme.colors.grey.primary.standard};
  width: 80px;
  min-width: 80px;
`;

export const RepsValue = styled.div`
  gap: 4px 12px;
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: baseline;
`;
